import {useCallback} from 'react'
import {
  UpdateLocationCallbackType,
  useUrlUpdater
} from 'components/data/WithUrlUpdater'

import {LayoutType, MapDisplayAction} from '../../modules/search/types'

export enum MapButtonPosition {
  Floating = 'Floating',
  Static = 'Static'
}

const showMap = (updateLocation: UpdateLocationCallbackType) => {
  updateLocation({layout: LayoutType.MAP})
}

const showList = (updateLocation: UpdateLocationCallbackType) => {
  updateLocation({layout: LayoutType.LIST})
}

const resetLayoutToDefault = (updateLocation: UpdateLocationCallbackType) => {
  updateLocation({layout: undefined}, {method: 'replace'})
}

export const useChangeMapLayout = () => {
  const {updateLocation} = useUrlUpdater()

  /**
   * Dispatches the correct event to hide, show, expand or minimize the map
   * @param requestedAction - an action that we want the map to do
   * @param withSplitView - whether the split view should be shown for relevant situations
   */
  return useCallback(
    (requestedAction: MapDisplayAction, withSplitView: boolean) => {
      switch (requestedAction) {
        case MapDisplayAction.EXPAND:
          showMap(updateLocation)
          break

        case MapDisplayAction.MINIMIZE:
          resetLayoutToDefault(updateLocation)
          break

        case MapDisplayAction.HIDE:
          showList(updateLocation)
          break

        case MapDisplayAction.SHOW:
          if (withSplitView) resetLayoutToDefault(updateLocation)
          if (!withSplitView) showMap(updateLocation)
          break

        default:
          break
      }
    },
    [updateLocation]
  )
}
